import * as React from "react";

export function HeaderKeywords({ query, keywordSuggestions }) {

  if (query.length > 0 || query == null) {
    return false;
  }

  return (
    <div className="popular-searches">
      <div className="popular-searches__container">
        <p className="popular-searches__title">Popular Searches</p>
        <div className="popular-searches__toggle" x-on:click="$store.global.toggleSearch()">
          <span className="sr-only">Close</span>
          <i className="icon icon-x-thin"></i>
        </div>
      </div>

      <ul>
        {keywordSuggestions.map((suggestion, index) => (
          <li
            className="popular-searches__suggestion"
            key={index}
            onClick={() => {
              const inputField: any = document.getElementById(
                "predictive-search-input",
              );
              if (inputField) {
                inputField.value = suggestion;
                const event = new Event("input", {
                  bubbles: true,
                });
                inputField.dispatchEvent(event);

                window.dispatchEvent(
                  new CustomEvent("searchInputUpdated", {
                    detail: {
                      value: suggestion,
                    },
                  }),
                );
              }
            }}
          >
            {suggestion}
          </li>
        ))}
      </ul>
    </div>
  );
}
